import { useInfiniteQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/jobs/constants';
import type { JobsFilterParamsApi, JobsPageApi } from '@/modules/jobs/types';

import { jobsQueryKeys } from './queryKeys';

const JOBS_FEED_PAGE_SIZE = 24;

export const useInfiniteJobsQuery = (params?: JobsFilterParamsApi) => {
  const query = useInfiniteQuery({
    queryKey: jobsQueryKeys.infiniteList(params),
    initialPageParam: undefined as string | undefined,
    queryFn: async ({ pageParam }) => {
      const { data } = await fetchClient.GET(endpoints.jobs, {
        params: {
          query: {
            ...params,
            cursor: pageParam,
            limit: JOBS_FEED_PAGE_SIZE,
          },
        },
      });

      return data;
    },
    getNextPageParam: (lastPage: JobsPageApi | undefined) =>
      lastPage?.nextCursor ?? undefined,
  });

  return {
    ...query,
    jobs: query.data?.pages.flatMap((page) => page?.items ?? []) ?? [],
  };
};
